import { render, staticRenderFns } from "./PurposeInfo.vue?vue&type=template&id=098e9dae&scoped=true&"
import script from "./PurposeInfo.vue?vue&type=script&lang=js&"
export * from "./PurposeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098e9dae",
  null
  
)

export default component.exports